import ReactGA from "react-ga";

export default {
  pageview: (params) => {
      if (window.OnetrustActiveGroups != null && window.OnetrustActiveGroups.split(',').includes('C0002')) {
      ReactGA.pageview(params);
    }
  },
  event: ({ category, action, label }) => {
      if (window.OnetrustActiveGroups != null && window.OnetrustActiveGroups.split(',').includes('C0002')) {
      ReactGA.event({ category, action, label });
    }
  },
};
